import { TokensAdmin } from '../components/admin/TokensAdmin';
import { ActivityAdmin } from '../components/admin/ActivityAdmin';
import { getAreaName } from '../lib/area';
import type { Me } from '@ft/shared';
import { NavLink, Navigate, useParams } from 'react-router-dom';
import { AreasAdmin } from '../components/admin/AreasAdmin';
import { ProjectsAdmin } from '../components/admin/ProjectsAdmin';
import { UsersAdmin } from '../components/admin/UsersAdmin';
import { useI18n } from '../i18n';
import { ImportPage } from './ImportPage';

const TABS = ['personen', 'bereiche', 'projekte', 'import', 'schluessel', 'protokoll'] as const;

/** Verwaltung (nur Admin): Personen, Projekte & Zuständigkeiten, Excel-Import. */
export function AdminPage({ me }: { me: Me }) {
  const { t } = useI18n();
  const { tab } = useParams();
  // Protokoll nur für Admins mit Häkchen „Protokoll“
  const tabs = TABS.filter((k) => k !== 'protokoll' || me.logAccess);
  if (!tabs.includes(tab as (typeof TABS)[number])) return <Navigate to="/verwaltung/personen" replace />;
  const label = { personen: t('admin.tab.users'), bereiche: t('admin.tab.areas'), projekte: t('admin.tab.projects'), import: t('admin.tab.import'), schluessel: t('admin.tab.tokens'), protokoll: t('admin.tab.log') };

  return (
    <section className="page">
      <div className="pagehead">
        <div><div className="crumb">{t('crumb.root', { area: getAreaName() })}</div><h1>{t('admin.title')}</h1></div>
      </div>
      <nav className="tabsbar" aria-label={t('admin.title')}>
        {tabs.map((k) => <NavLink key={k} to={`/verwaltung/${k}`} className={({ isActive }) => (isActive ? 'active' : '')}>{label[k]}</NavLink>)}
      </nav>
      {tab === 'personen' && <UsersAdmin me={me} />}
      {tab === 'bereiche' && <AreasAdmin />}
      {tab === 'projekte' && <ProjectsAdmin />}
      {tab === 'import' && <ImportPage />}
      {tab === 'schluessel' && <TokensAdmin />}
      {tab === 'protokoll' && me.logAccess && <ActivityAdmin />}
    </section>
  );
}
